import Modal from '../Modal'
import DefaultButton from '../Button/Button'

interface Props {
  open: boolean
  onClose: () => void
  data: any
}

const AccessHistoryDetailModal = ({ open, onClose, data }: Props) => {
  if (!data) return null

  return (
    <Modal open={open} close={onClose} widthClass="w-[calc(10%-16px)] sm:w-[90vw]">
      <div className="p-4 space-y-3">
        <section className="flex justify-between">
          <div className="flex flex-col gap-3">
            <h2 className="text-xl font-semibold text-[#212529]">Access Details</h2>
            <p className="text-[#495057] font-medium"> {data.propertyAddress} </p>
          </div>
          <button
            onClick={onClose}
            className=" text-[#ADB5BD] hover:text-black text-xl sm:text-2xl transition-colors flex justify-end "
          >
            &times;
          </button>
        </section>

        <section className="rounded p-4 space-y-4 font-medium bg-[#F8F9FA]">
          <div className="flex gap-5">
            <p className="text-[#6C757D]">Resident:</p> {data.residentName}
          </div>

          <div className="flex gap-5">
            <p className="text-[#6C757D]">Property Address:</p> {data.propertyAddress}
          </div>

          <div className="flex gap-5">
            <p className="text-[#6C757D]">Action:</p> {data.action}
          </div>

          {/* <div className="flex gap-5">
            <p className="text-[#6C757D]">Action Type:</p> {data.actionType}
          </div> */}

          <div className="flex gap-5">
            <p className="text-[#6C757D]">Triggered By:</p> {data.triggeredBy}
          </div>

          <div className="flex gap-5">
            <p className="text-[#6C757D]">Reason:</p> {data.reason}
          </div>

          <div className="flex gap-5">
            <p className="text-[#6C757D]">Timestamp:</p> {data.dateTime}
          </div>

          <div className="flex gap-5">
            <p className="text-[#6C757D]">Status:</p>{' '}
            <p className={data.status === 'Active' ? 'text-green-600' : 'text-red-600'}>
              {data.status}
            </p>
          </div>
        </section>

        <div className="flex justify-end">
          <DefaultButton onClick={onClose} buttonType='primary' className="border border-[#CED4DA]text-black">
            Close
          </DefaultButton>
        </div>
      </div>
    </Modal>
  )
}

export default AccessHistoryDetailModal
